<script>
    import { beforeUpdate } from 'svelte'
    import Artboard from "./lib/artboard.svelte"
    import Totem from "./lib/totem.svelte"

    let getHash
    let allPalettes = [
        {"colors" : ["#D7D9D7", "#C9C5CB", "#BAACBD", "#B48EAE", "#8C7E8B", "#646E68"], "name" : "Dream Puddle"},
        {"colors" : ["#ccd5ae", "#e9edc9", "#fefae0", "#faedcd", "#d4a373"], "name" : "Light Natural"},
        {"colors" : ["#231942", "#5e548e", "#9f86c0", "#be95c4", "#e0b1cb"], "name" : "Purple Glow"},
        {"colors" : ["#3d5a80", "#98c1d9", "#e0fbfc", "#ee6c4d", "#293241"], "name" : "Artistic Switch"},
        {"colors" : ["#C6D4FF", "#7A82AB", "#307473", "#12664F", "#209486", "#2DC2BD"], "name" : "Kelly"},
        {"colors" : ["#F92A82", "#ED7B84", "#F5DBCB", "#D6D5B3", "#7EB77F", "#9FC9A0"], "name" : "Summer"},
        {"colors" : ["#223843", "#EFF1F3", "#DBD3D8", "#D8B4A0", "#D77A61", "#E19B88"], "name" : "Terra Cotta"},
        {"colors" : ["#551CA8", "#6622CC", "#A755C2", "#B07C9E", "#B59194", "#D2A1B8"], "name" : "Opera Mauve"},
        {"colors" : ["#C9D09D", "#8B7B87", "#AFB4BA", "#CCE0DE", "#DAE9E6", "#ECEAE8"], "name" : "Beachouse"},
        {"colors" : ["#F8F8E6", "#E1DBF0", "#C4BFE3", "#9A86B3", "#6D5B74", "#986F95"], "name" : "Hydrangea"},
        {"colors" : ["#ECD6D9", "#F3C2BD", "#E38A8A", "#997976", "#A69777", "#DFD6CF"], "name" : "Crochet"},
        {"colors" : ["#E5DAE8", "#DBCEDF", "#B2ABC1", "#948490", "#B596A5", "#ECEED1"], "name" : "Autumn"},
        {"colors" : ["#ECEEF6", "#DFD6EB", "#BE9BCD", "#935FAA", "#49455D", "#7C6692"], "name" : "Amethyst"},
        {"colors" : ["#EDEBED", "#F2DCE3", "#EECCD3", "#836D6E", "#5972A4", "#C5D7D2"], "name" : "Refresh"}
    ]
    let chosenPalette
    $: bgColor = ""
    let allVariations = [
        "single",
        "double",
        "quad",
        "six"
    ]
    let overlayEnabled = false
    let overlayCutoutEnabled = false
    $: chosenVariation = ""

    beforeUpdate(() => {
        getHash = fxhash

        chosenPalette = allPalettes[Math.floor( fxrand() * allPalettes.length )]

        let bgIndex = Math.floor( fxrand() * chosenPalette.colors.length )
        bgColor = chosenPalette.colors[bgIndex]
        chosenPalette.colors.splice(bgIndex, 1)

        chosenVariation = allVariations[Math.floor( fxrand() * allVariations.length )]

        if (fxrand() > .5) {overlayCutoutEnabled = true}
        if (fxrand() > .5) {overlayEnabled = true}

        window.$fxhashFeatures = {
            "Layout": chosenVariation,
            "Totem Wear": overlayCutoutEnabled,
            "Canvas Wear": overlayEnabled
        }
    });
</script>

<style>
    .container {
        height: 100vh;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>

<div class="container">
    <Artboard chosenPalette={chosenPalette} bgColor={bgColor} overlayCutoutEnabled={overlayCutoutEnabled} overlayEnabled={overlayEnabled}>

        {#if chosenVariation == "single"}

            <div style="width: 25%">
                <Totem chosenPalette={chosenPalette} bgColor={bgColor}/>
            </div>

        {:else if chosenVariation == "double"}

            <div style="display: flex; flex-direction: row; width: 60%">
                <Totem chosenPalette={chosenPalette} bgColor={bgColor} />
                <Totem chosenPalette={chosenPalette} bgColor={bgColor} passStyle="margin-left: 10%"/>
            </div>

        {:else if chosenVariation == "quad"}

            <div style="display: flex; flex-direction: column; width: 50%;">
                <div style="display: flex; flex-direction: row;">
                    <Totem chosenPalette={chosenPalette} bgColor={bgColor} stack=2/>
                    <Totem chosenPalette={chosenPalette} bgColor={bgColor} passStyle="margin-left: 25%" stack=2 />
                </div>
                <div style="display: flex; flex-direction: row; margin-top: 25%; margin-left: 0%;">
                    <Totem chosenPalette={chosenPalette} bgColor={bgColor} stack=2 />
                    <Totem chosenPalette={chosenPalette} bgColor={bgColor} passStyle="margin-left: 25%" stack=2 />
                </div>
            </div>

        {:else if chosenVariation == "six"}

            <div style="display: flex; flex-direction: column; width: 70%;">
                <div style="display: flex; flex-direction: row;">
                    <Totem chosenPalette={chosenPalette} bgColor={bgColor} stack=2 />
                    <Totem chosenPalette={chosenPalette} bgColor={bgColor} passStyle="margin-left: 15%" stack=2 />
                    <Totem chosenPalette={chosenPalette} bgColor={bgColor} passStyle="margin-left: 15%" stack=2 />
                </div>
                <div style="display: flex; flex-direction: row; margin-top: 25%; margin-left: 0">
                    <Totem chosenPalette={chosenPalette} bgColor={bgColor} stack=2 />
                    <Totem chosenPalette={chosenPalette} bgColor={bgColor} passStyle="margin-left: 15%" stack=2 />
                    <Totem chosenPalette={chosenPalette}  bgColor={bgColor} passStyle="margin-left: 15%" stack=2 />
                </div>
            </div>

        {/if}
        
    </Artboard>
</div>